



















import { Component, Mixins } from "vue-property-decorator";
import { RectangleDragHandles } from "../../../../../../base/components/dragging";
import { CheckBoxDrawer } from "../../../../../../base/components/drawing/drawers";
import { Rectangle, Point, Size, LineStyle, PaintStyle, Color, LineKinds } from "../../../../../../base/domain/drawing";
import { CheckableObjectDrawerBase } from "./base";
import { CheckStylePropertyEditableMixin } from "../../mixins/properties";

@Component({
  components: {
    CheckBoxDrawer,
    RectangleDragHandles,
  },
})
export default class CheckObjectDrawer extends Mixins(CheckableObjectDrawerBase, CheckStylePropertyEditableMixin) {
  mounted() {
    this.styleKey = "CheckBox";
  }

  get shapeRectangle(): Rectangle {
    return new Rectangle(
      new Point(-1, -1),
      new Size(Math.max(this.offsetRectangleCoordinate.size.width, 1), Math.max(this.offsetRectangleCoordinate.size.height, 1)));
  }

  get borderStyle(): LineStyle {
    return this.checkStyle.border.isEnable && !!this.configuration
      ? new LineStyle(new Color("#000000"), LineKinds.Normal, 1)
      : new LineStyle(new Color("transparent"), LineKinds.Normal, 1);
  }

  get textureStyle(): PaintStyle {
    return new PaintStyle(new Color("transparent"));
  }
}
